import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Button, F } from 'components/Ui';
import { Mobile, Default } from 'components/Media';
import { apiCall } from 'utils/swaggerClient';
import { createDownloadLink } from 'utils/fileDownload';
import Loader from 'components/Loader';
import {
  selectRecentTransactions,
  selectIsFetchingRecentTransactions,
} from 'containers/PrimoAccount/selectors';
import { loadRecurringOrder } from 'containers/PrimoAccount/actions';
import { showErrorSnackbar } from 'components/Notifier/actions';
import IconButton from '@material-ui/core/IconButton';
import { formatCurrency } from 'utils/common';
import get from 'lodash/get';
import { CloseExpandIcon } from 'components/Ui/CustomIcons';
import ExpandIcon from 'components/Ui/CustomIcons/ExpandIcon';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import DeliveryItem from './DeliveryItem';

import styles from './styles.scss';

const RecentTransactionsList = (props) => {
  const [expanded, setExpanded] = useState(false);
  const onAction = (product) => {
    if (product.isRecurring) {
      props.loadRecurringOrder();
    }
  };

  const getDeliveryTicket = async (transaction, e) => {
    e.preventDefault();
    e.stopPropagation();
    const { transactionDate: deliveryDate, serviceLocationId } = transaction;
    try {
      const { data } = await apiCall({
        operationId: 'ServiceLocations.getServiceLocationDeliveryTicket',
        parameters: { serviceLocationId, deliveryDate },
        fullResponse: true,
      });

      createDownloadLink({
        data,
        fileName: `Delivery_ticket_${deliveryDate}.pdf`,
      });
    } catch (err) {
      props.showErrorSnackbar('Error generating ticket');
    }
  };

  const renderOrderItem = (transaction) => (
    <ExpansionPanel
      key={transaction.transactionId}
      className={styles.orderList}
    >
      <ExpansionPanelSummary
        className={styles.date}
        data-tracking={`${transaction.transactionDate} Delivery`}
      >
        <div style={{ flex: 2 }}>
          <h2>
            {transaction.transactionDate} <F>Delivery</F>
          </h2>
          <Mobile>
            {/* <p>#{transaction.serviceLocationId}</p> */}
            <Button
              link
              className={styles.printInvoice}
              onClick={(e) => getDeliveryTicket(transaction.transactionDate, e)}
              text="View/Print Delivery Ticket"
            />
          </Mobile>
        </div>
        <Mobile>
          <h3 className={styles.priceLabel}>
            {formatCurrency(get(transaction, 'total', 0))}
          </h3>
          <IconButton
            className={styles.iconExpanded}
            onClick={() => {
              setExpanded(!expanded);
            }}
            aria-expanded={expanded}
            aria-label="show more"
          >
            {expanded ? <CloseExpandIcon /> : <ExpandIcon />}
          </IconButton>
        </Mobile>
        <Default>
          {/* <p>#{transaction.serviceLocationId}</p> */}
          <Button
            className={styles.printInvoice}
            onClick={(e) => getDeliveryTicket(transaction, e)}
            text="View/Print Delivery Ticket"
            link
          />
          <h3 className={styles.priceLabel}>
            {formatCurrency(get(transaction, 'total', 0))}
          </h3>
          <IconButton
            className={styles.iconExpanded}
            onClick={() => {
              setExpanded(!expanded);
            }}
            aria-expanded={expanded}
            aria-label="show more"
          >
            {expanded ? <CloseExpandIcon /> : <ExpandIcon />}
          </IconButton>
        </Default>
      </ExpansionPanelSummary>
      <ExpansionPanelDetails className={styles.Panel}>
        {props.isDisplayProducts && (
          <DeliveryItem
            isTableLayout
            key={transaction.transactionDate}
            delivery={transaction}
            getDeliveryTicket={(e) => {
              getDeliveryTicket(transaction, e);
            }}
            isRecurring={transaction.isRecurring}
            onAction={onAction}
          />
        )}
      </ExpansionPanelDetails>
    </ExpansionPanel>
  );

  const recentTransactions = props.recentTransactions || [];
  return (
    <Loader local loading={props.isFetchingRecentTransactions}>
      {recentTransactions.map(renderOrderItem)}
    </Loader>
  );
};

RecentTransactionsList.propTypes = {
  recentTransactions: PropTypes.arrayOf(PropTypes.object).isRequired,
  showErrorSnackbar: PropTypes.func.isRequired,
  loadRecurringOrder: PropTypes.func,
  isDisplayProducts: PropTypes.bool,
  isFetchingRecentTransactions: PropTypes.bool,
};

RecentTransactionsList.defaultProps = {};

const mapStateToProps = createStructuredSelector({
  recentTransactions: selectRecentTransactions(),
  isFetchingRecentTransactions: selectIsFetchingRecentTransactions(),
});
const mapDispatchToProps = {
  loadRecurringOrder,
  showErrorSnackbar,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(RecentTransactionsList);
